import { ValidUtils as CoreValidUtils } from "@dooboostore/core";
var ValidUtils;
((ValidUtils2) => {
  ValidUtils2.coreValidUtils = CoreValidUtils;
  ValidUtils2.isBrowser = (callBack) => {
    const boolean = typeof window !== "undefined" && typeof Window !== "undefined";
    if (boolean && callBack) {
      callBack(window);
    }
    return boolean;
  };
  ValidUtils2.hasParentWindow = (win) => ValidUtils2.isBrowser() && win.parent && win !== win.parent;
  ValidUtils2.isSocialNetworkServiceInappBrowser = () => {
    const userAgent = ValidUtils2.isBrowser() ? window.navigator.userAgent.toLowerCase() : "none";
    return /kakaotalk|naver|facebook|insta|FBAN|FBAV/.test(userAgent);
  };
  ValidUtils2.isWkWebview = () => ValidUtils2.isBrowser() && window["webkit"] != null && window["webkit"].messageHandlers != null && window["webkit"].messageHandlers["System"] != null;
  function isiPhone() {
    return ValidUtils2.isBrowser() && /iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase());
  }
  ValidUtils2.isiPhone = isiPhone;
  ValidUtils2.isAndroidWebview = () => {
    return ValidUtils2.isBrowser() && window["System"] != null;
  };
  ValidUtils2.isMobile = (win) => {
    const targetWindow = win ?? ((0, ValidUtils2.isBrowser)() ? window : void 0);
    if (!targetWindow) {
      return false;
    }
    return /Mobi/i.test(targetWindow.navigator.userAgent);
  };
})(ValidUtils || (ValidUtils = {}));
export {
  ValidUtils
};
//# sourceMappingURL=ValidUtils.js.map
